// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 6842 ? "map" : chunkId) + "." + {"1194":"b083b8f9","6842":"9774411f"}[chunkId] + ".chunk.css";
};